import React, { ReactElement } from "react";
import { Checkbox } from "@components/form";
import { useState } from "@helpers/Store";

interface IProps {
  setNetworkingProfile: any;
  languagesList: number[];
  networkingProfile: {
    interestCompanyTypes: number[];
    languages: number[];
    directions: number[];
    specializations: number[];
    about: string;
  };
  editMode: boolean;
}

const Language = ({
  languagesList,
  networkingProfile,
  setNetworkingProfile,
  editMode,
}: IProps): ReactElement => {
  // const [selectedLanguages, setSelectedLanguages] = useState(networkingProfile.languages)

  const onCheckHandler = (
    event: React.ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >
  ): void => {
    if (networkingProfile?.languages?.includes(+event.target.value)) {
      networkingProfile?.languages?.splice(
        networkingProfile?.languages?.indexOf(+event.target.value),
        1
      );
    } else {
      networkingProfile?.languages?.push(+event.target.value);
    }
    setNetworkingProfile({ ...networkingProfile });
  };

  if (editMode) {
    return (
      <div className="profile-netw-step">
        <div className="profile-netw-step__body">
          <div className="profile-netw-step__body-header">
            <p className="profile-netw-step__title">
              На каком языке вы планируете общаться в нетворкинге ?
            </p>
          </div>

          <p className="profile-netw-step__desc">
            Выберите хотя бы одно значение
          </p>
          <div className="profile-netw-step__main profile-netw-step__main--checkbox-list">
            {languagesList?.map((Item: any) => {
              return (
                <Checkbox
                  key={Item.id}
                  name="languages"
                  type="profile-language"
                  placeholder={Item.name}
                  value={Item.id}
                  hiddenInput
                  checked={networkingProfile?.languages?.includes(Item.id)}
                  onChange={onCheckHandler}
                />
              );
            })}
          </div>
        </div>
      </div>
    );
  } else {
    return (
      <div className="profile-netw-step">
        <div className="profile-netw-step__body">
          <div className="profile-netw-step__body-header">
            <p className="profile-netw-step__title">
              На каком языке вы планируете общаться в нетворкинге ?
            </p>
          </div>

          <div className="profile-netw-step__main profile-netw-step__main--item-list">
            {languagesList?.map((Item: any) => {
              return networkingProfile?.languages?.includes(Item.id) ? (
                <div key={Item.id} className="profile-netw-step__main-item">
                  {Item.name}
                </div>
              ) : (
                <></>
              );
            })}
          </div>
        </div>
      </div>
    );
  }
};

export default Language;
